import { Injectable } from '@angular/core';
import { IInternalUser } from '@app/interfaces';
import { LucienDataService } from './data';
import { UtilityService } from './root';

@Injectable()
export class ClientUtilityService {
    constructor(
        private lucienDataService: LucienDataService,
        private utilityService: UtilityService
    ) { }

    public async getClientInformation(): Promise<void> {
        await this.utilityService.getClientNetInformation()
            .then((internalUser: IInternalUser) => {
                const { internal } = internalUser;
                this.lucienDataService.setClientUtilityInfo(internalUser);
                this.lucienDataService.setIsInternalUser(internal);
            });
    }

}
